/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {TopNavNotificationIcon} from '../icons/TopNavNotificationIcon';
import {dlsColor} from '../theme/theme';
import {DLSTheme, IconSize} from '../types/types';

export interface EmptyNotificationsType {
  title: string;
  desktopHeight?: string;
  mobileHeight?: string;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  emptyNotifications : {
    height                         : ({desktopHeight}: {desktopHeight: string}) => desktopHeight,
    display                        : 'flex',
    justifyContent                 : 'center',
    alignItems                     : 'center',
    flexDirection                  : 'column',
    [theme.breakpoints.down('sm')] : {
      height : ({mobileHeight}: {mobileHeight: string}) => mobileHeight
    }
  },
  emptyNotificationsIcon : {
    margin : '-70px 0 24px'
  },
  emptyNotificationsText : {
    fontFamily : 'Roboto',
    fontWeight : 500,
    fontSize   : '24px',
    lineHeight : '28px',
    color      : dlsColor('grey2')
  }
}));

export const EmptyNotifications = ({
  title,
  desktopHeight = '100%',
  mobileHeight = '100%'
}: EmptyNotificationsType) => {
  const classes = useStyles({desktopHeight, mobileHeight});
  return (
    <div className={classes.emptyNotifications}>
      <div className={classes.emptyNotificationsIcon}>
        <TopNavNotificationIcon size={IconSize.large} />
      </div>
      <div className={classes.emptyNotificationsText}>{title}</div>
    </div>
  );
};

export default EmptyNotifications;
